import { AssessmentDescriptiveValues } from "app/pages/CalorieFriend/PatientSheetView/Assessments/DescriptiveValues";
import { getKeyValueFromJson } from "./utility";

export const defaultFormValues = [
  {
    key: 'height',
    type: 'nbInputNumber',
    name: 'Height',
    templateOptions: {
      minLength: 0,
      maxLength: 10,
      label: 'Height',
      placeholder: 'Height',
    },
    defaultField: true,
  },
  {
    key: 'weight',
    type: 'nbWeight',
    name: 'Weight',
    templateOptions: {
      minLength: 0,
      maxLength: 10,
      label: 'Weight',
      placeholder: 'Weight',
    },
    defaultField: true,
  },
  {
    key: 'bodyFat',
    type: 'nbInputNumber',
    name: 'Body Fat',
    templateOptions: {
      min: 0,
      max: 100,
      pattern: '^-?[0-9]*\.?[0-9]{0,1}$',
      label: 'Body Fat',
      placeholder: 'Body Fat',
    },
    defaultField: true,
  },
  {
    key: 'mealPlanCompliance',
    type: 'nbSelect',
    name: 'Meal Plan Compliance',
    templateOptions: {
      required: true,
      label: 'Meal Plan Compliance',
      placeholder: "Meal Plan Compliance",
      options: getKeyValueFromJson(AssessmentDescriptiveValues.MealPlanComplianceValues),
    },
    defaultField: true,
  },
  {
    key: 'energyLevel',
    type: 'nbSelect',
    name: 'Energy Level',
    templateOptions: {
      required: true,
      options: getKeyValueFromJson(AssessmentDescriptiveValues.EnergyLevelValues),
      label: 'Energy Level',
      placeholder: 'Energy Level',
    },
    defaultField: true,
  },
  {
    key: 'stressLevel',
    type: 'nbSelect',
    name: 'Stress Level',
    templateOptions: {
      required: true,
      options: getKeyValueFromJson(AssessmentDescriptiveValues.StressLevelValues),
      label: 'Stress Level',
      placeholder: 'Stress Level',
    },
    defaultField: true,
  },
  {
    key: 'sleepQuality',
    type: 'nbSelect',
    name: 'Sleep Quality',
    templateOptions: {
      required: true,
      options: getKeyValueFromJson(AssessmentDescriptiveValues.SleepQualityValues),
      label: 'Sleep Quality',
      placeholder: 'Sleep Quality',
    },
    defaultField: true,
  },
  {
    key: 'comment',
    type: 'nbTextarea',
    name: 'Comment',
    templateOptions: {
      minLength: 0,
      maxLength: 1000,
      label: 'Comment',
      placeholder: 'Comment',
    },
    defaultField: true,
  },
];
